module.exports = require("@splunk/dashboard-visualizations/Ellipse");